import React, { useState } from 'react';
import PowerManagement from './PowerManagement';
import './SettingsPage.css';
import NotificationPreferences from './NotificationPreferences';

/**
 * Settings Page with Power Management
 */
const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('power');

  const tabs = [
    { id: 'power', label: '⚡ Power Management', icon: '🔋' },
    { id: 'trading', label: '📈 Trading Settings', icon: '⚙️' },
    { id: 'notifications', label: '🔔 Notifications', icon: '📢' },
    { id: 'security', label: '🔒 Security', icon: '🛡️' }
  ];

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h1>⚙️ Settings</h1>
        <p>Configure your trading bot preferences and power management</p>
      </div>

      <div className="settings-container">
        <div className="settings-sidebar">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="settings-content">
          {activeTab === 'power' && (
            <div className="settings-section">
              <PowerManagement />
            </div>
          )}
          
          {activeTab === 'trading' && (
            <div className="settings-section">
              <h3>📈 Trading Settings</h3>
              <p>Trading configuration options will go here...</p>
              {/* Add your existing trading settings here */}
            </div>
          )}
          
          {activeTab === 'notifications' && (
            <div className="settings-section">
              <h3>🔔 Notification Settings</h3>
              <p>Notification preferences will go here...</p>
              <NotificationPreferences />
              {/* Add notification settings here */}
            </div>
          )}
          
          {activeTab === 'security' && (
            <div className="settings-section">
              <h3>🔒 Security Settings</h3>
              <p>Security and privacy options will go here...</p>
              {/* Add security settings here */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;